module.exports = __webpack_public_path__ + "img/honourable.b4fefd0d.png";